module.exports = __webpack_public_path__ + "img/Check-filled.2c7274f4.svg";